import styled from "styled-components";
import { colours } from "../../../../styles/colours.constants";

export const PostActions = styled.div`
	position: relative;
	background-color: ${colours.greyMedium};
	padding: 0.3rem;
	border-radius: 100%;
	width: 38px;
	height: 38px;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
	&:hover {
		background-color: ${colours.greyDark};
	}
`;
